import { PanelView, PanelViewProvider, usePanelView } from '../../PanelView';
import {
  APP_VIEW_ICONS,
  APP_VIEW_TITLES,
  AppViewType,
  useAppView,
} from '../../../contexts/AppViewContext';
import React from 'react';
import { AppViewHeader } from './AppViewHeader';
import { OperatorOptions } from './OperatorOptions';
import { RDPOptions } from './RDPOptions';

export const EntityOptions = ({ onClose }: { onClose(): void }) => {
  const { setActivePanel } = usePanelView();
  const appView = useAppView();

  const handleSelect = (selection: {
    id: string;
    code: string;
    sector: OperatorType;
  }) => {
    appView.changePendingView({ ...selection }, true);
    onClose();
  };

  return (
    <PanelViewProvider defaultView={appView.pending.type}>
      <AppViewHeader>
        {(activePanel) => (
          <React.Fragment>
            <p className="inline-flex items-center flex-1 gap-3 font-bold">
              {appView.pending.type &&
                APP_VIEW_ICONS('small')[activePanel as AppViewType]}
              Select {APP_VIEW_TITLES[activePanel as AppViewType].OPTIONS}
            </p>
            {(appView.permissions.canViewRDP ||
              appView.permissions.canViewNDP) && (
              <button
                className="hover:text-primary text-xs"
                onClick={() => setActivePanel('View')}
                type="button"
              >
                Change View
              </button>
            )}
          </React.Fragment>
        )}
      </AppViewHeader>
      <PanelView id="Operator">
        <OperatorOptions onSelect={handleSelect} onClose={onClose} />
      </PanelView>

      <PanelView id="RDP">
        <RDPOptions onSelect={handleSelect} />
      </PanelView>
    </PanelViewProvider>
  );
};
